import React  from 'react';  

export const consultationConfig = [
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/appointment/video-consultation-old',
        component: React.lazy(() => import('./VideoConsultation')),
      },
      {
        exact:false,
        path: '/appointment/video-consultation',
        component: React.lazy(() => import('./VideoConsultation2')),
      },
      {
        exact:false,
        path: '/appointment/mobile-video-consultation',
        component: React.lazy(() => import('./VideoConsultation2/MobileViewIndex')),
      },
    ],
  },
 
];